var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnloverLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fill: "rgb(255, 236, 245)"
    },
    d: "M 471.95 470.696 C 471.95 390.687 481.478 303.854 470.135 224.663 C 464.133 182.765 450.291 143.376 423.303 110.13 C 402.843 84.925 377.92 64.31 348.933 49.725 C 323.341 36.846 296.717 29.993 268.338 26.505 C 88.102 4.372 -31.844 207.95 51.118 360.405 C 66.603 388.86 89.492 413.76 115.627 432.827 C 145.626 454.709 180.97 467.379 217.433 473.075 C 247.517 477.775 278.429 474.594 306.514 462.737 C 321.12 456.573 353.175 440.422 353.175 440.422 C 353.175 440.422 385.482 455.916 399.838 461.813 C 423.345 471.467 447.045 470.696 471.95 470.696 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fill: "rgb(255, 255, 255)"
    },
    d: "M 217.433 473.075 C 180.97 467.379 145.626 454.709 115.627 432.827 C 89.492 413.76 66.603 388.86 51.118 360.405 C -28.56 213.982 78.927 20.402 247.233 24.92 L 247.233 475.127 C 237.301 475.314 227.323 474.619 217.433 473.075 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fill: "rgb(245, 22, 96)"
    },
    d: "M 172.65 156.407 C 162.356 159.654 151.14 165.526 143.791 173.433 C 93.358 227.743 151.724 296.738 194.515 332.858 C 210.379 346.249 233.692 371.65 256.667 363.658 C 270.844 358.734 283.524 346.168 294.912 336.798 C 339.448 300.149 406.607 224.184 346.483 169.513 C 312.717 138.81 247.101 168.636 247.101 168.636 C 247.101 168.636 201.65 147.274 172.65 156.407 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(255, 253, 254)",
      stroke: "none"
    },
    d: "M 196.623 287.719 C 181.602 254.535 178.773 226.202 187.506 184.526 C 136.146 201.095 164.976 264.889 196.623 287.719 Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnloverLogo);
export default __webpack_public_path__ + "static/media/anlover_logo.e34dd17522ac275c59a9008a6a3220ab.svg";
export { ForwardRef as ReactComponent };